import * as d from "react";
import { p as i } from "./index-efd35e77.js";
import { B as C } from "./Button-4c83e316.js";
import { g as b, n as k, d as f, a as y, P as v, b as I, c as D, B as w } from "./popup-da16fa2b.js";
import { v as _, c as m, p as x } from "./package-metadata-9ad1330d.js";
import { K as a } from "./keys-2b65407d.js";
import { k as O, s as P } from "./theme-b013fa81.js";
var S = globalThis && globalThis.__extends || function() {
  var r = function(s, n) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, r(s, n);
  };
  return function(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    r(s, n);
    function e() {
      this.constructor = s;
    }
    s.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
  };
}(), E = (
  /** @class */
  function(r) {
    S(s, r);
    function s() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return s.prototype.render = function() {
      return null;
    }, s.propTypes = {
      text: i.string,
      icon: i.string,
      iconClass: i.string,
      imageUrl: i.string,
      selected: i.bool,
      disabled: i.bool,
      render: i.any
    }, s;
  }(d.Component)
), B = globalThis && globalThis.__extends || function() {
  var r = function(s, n) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, r(s, n);
  };
  return function(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    r(s, n);
    function e() {
      this.constructor = s;
    }
    s.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
  };
}(), g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(r) {
    for (var s, n = 1, e = arguments.length; n < e; n++) {
      s = arguments[n];
      for (var t in s)
        Object.prototype.hasOwnProperty.call(s, t) && (r[t] = s[t]);
    }
    return r;
  }, g.apply(this, arguments);
}, R = (
  /** @class */
  function(r) {
    B(s, r);
    function s(n) {
      var e = r.call(this, n) || this;
      return e.state = {
        opened: !1,
        focused: !1,
        focusedIndex: -1
      }, e.wrapper = null, e.mainButton = null, e.list = null, e.skipFocus = !1, e.guid = b(), e.buttonsData = [], e.onKeyDown = function(t) {
        var o = e.state.focusedIndex;
        if (t.altKey) {
          !e.opened && t.keyCode === a.down ? (e.setOpen(!0), e.dispatchPopupEvent(t, !0), e.setState({ focusedIndex: 0 })) : e.opened && t.keyCode === a.up && (e.setState({ focusedIndex: -1 }), e.setOpen(!1));
          return;
        }
        var p = g({}, e.state);
        if (t.keyCode === a.enter || t.keyCode === a.space) {
          o >= 0 && e.dispatchClickEvent(t, o), t.preventDefault();
          var l = !e.opened;
          e.setOpen(l), l && (e.dispatchPopupEvent(t, !0), e.setState({ focusedIndex: e.opened ? -1 : 0 }));
          return;
        } else if (e.opened && t.keyCode === a.esc) {
          e.setState({ focusedIndex: -1 }), e.setOpen(!1);
          return;
        }
        if (e.opened) {
          var c = k(o, t.keyCode, t.altKey, e.buttonsData.length);
          p.focusedIndex = c;
          var h = t.keyCode === a.up || t.keyCode === a.down || t.keyCode === a.left || t.keyCode === a.right;
          !t.altKey && (h || t.keyCode === a.home || t.keyCode === a.end) && t.preventDefault();
        }
        e.setState(p);
      }, e.switchFocus = function(t) {
        e.skipFocus = !0, t(), window.setTimeout(function() {
          return e.skipFocus = !1;
        }, 0);
      }, e.handleFocus = function(t) {
        e.skipFocus || (e.setState({ focused: !0, focusedIndex: e.opened ? 0 : -1 }), f(e.props.onFocus, t, e, void 0));
      }, e.handleBlur = function(t) {
        e.skipFocus || (e.setState({ focused: !1, focusedIndex: -1 }), e.setOpen(!1), f(e.props.onBlur, t, e, void 0));
      }, e.setOpen = function(t) {
        e.openedDuringOnChange = t, e.setState({ opened: t });
      }, e.onItemClick = function(t, o) {
        e.setState({ focusedIndex: -1 }), e.setOpen(!1), e.dispatchClickEvent(t, o);
      }, e.onItemDown = function(t) {
        var o = y(document);
        o === e.list && t.preventDefault();
      }, e.mouseDown = function(t) {
        t.preventDefault();
        var o = y(document);
        e.element && o !== e.element && o !== e.list && e.element.focus();
      }, e.onPopupClose = function() {
        e.state.focused && e.switchFocus(function() {
          e.element && (e.element.removeAttribute("tabindex"), e.element.focus({ preventScroll: !0 }));
        }), e.dispatchPopupEvent({}, !1);
      }, e.listRef = function(t) {
        e.list = t, t && e.state.focused && e.switchFocus(function() {
          t.focus({ preventScroll: !0 }), e.element && (e.element.tabIndex = -1);
        });
      }, e.onClickMainButton = function(t) {
        if (e.buttonsData.length) {
          var o = !e.opened;
          e.setState({
            focused: !0,
            focusedIndex: o ? 0 : -1
          }), e.setOpen(o), o && e.dispatchPopupEvent(t, o);
        }
      }, e.dispatchPopupEvent = function(t, o) {
        f(o ? e.props.onOpen : e.props.onClose, t, e, void 0), e.openedDuringOnChange = void 0;
      }, _(x), e;
    }
    return Object.defineProperty(s.prototype, "opened", {
      get: function() {
        return this.openedDuringOnChange !== void 0 ? this.openedDuringOnChange : this.props.opened === void 0 ? this.state.opened : this.props.opened;
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.render = function() {
      var n = this, e = this.isRtl(), t = e ? "rtl" : void 0, o = this.props, p = o.id, l = o.style, c = o.tabIndex, h = o.disabled;
      return this.buttonsData = this.props.items || d.Children.toArray(this.props.children).filter(function(u) {
        return u && u.type === E;
      }).map(function(u) {
        return u.props;
      }), d.createElement(
        "div",
        { id: p, style: l, className: m("k-dropdown-button", {
          "k-focus": this.state.focused
        }, this.props.className), onKeyDown: this.onKeyDown, onFocus: this.handleFocus, onBlur: this.handleBlur, dir: t, ref: function(u) {
          return n.wrapper = u;
        } },
        d.createElement(C, { size: this.props.size, rounded: this.props.rounded, fillMode: this.props.fillMode, themeColor: this.props.themeColor, onClick: this.onClickMainButton, onMouseDown: this.mouseDown, disabled: h || void 0, tabIndex: c, accessKey: this.props.accessKey, icon: this.props.icon, svgIcon: this.props.svgIcon, iconClass: this.props.iconClass, className: this.props.buttonClass, imageUrl: this.props.imageUrl, dir: t, ref: function(u) {
          return n.mainButton = u && u.element;
        }, type: "button", "aria-haspopup": !0, "aria-expanded": this.opened || void 0, "aria-label": this.props.ariaLabel, "aria-controls": this.opened ? this.guid : void 0, id: "button-" + this.guid, title: this.props.title }, this.props.text),
        this.renderPopup(e)
      );
    }, s.prototype.componentDidMount = function() {
      (this.props.dir === void 0 && this.isRtl() || this.opened) && this.forceUpdate();
    }, Object.defineProperty(s.prototype, "element", {
      /**
       * The DOM element of main button.
       */
      get: function() {
        return this.mainButton;
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.dispatchClickEvent = function(n, e) {
      this.isItemDisabled(e) || f(this.props.onItemClick, n, this, {
        item: this.buttonsData[e],
        itemIndex: e
      });
    }, s.prototype.renderPopup = function(n) {
      var e, t = this.props.popupSettings, o = t === void 0 ? {} : t, p = this.state.focusedIndex;
      return d.createElement(
        v,
        { anchor: this.wrapper, show: this.opened, animate: o.animate, popupClass: m("k-menu-popup", o.popupClass), anchorAlign: o.anchorAlign || I(n), popupAlign: o.popupAlign || D(n), style: n ? { direction: "rtl" } : void 0, onClose: this.onPopupClose },
        d.createElement("ul", { role: "menu", id: this.guid, "aria-labelledby": "button-" + this.guid, tabIndex: -1, "aria-activedescendant": p >= 0 ? "".concat(this.guid, "-").concat(p) : void 0, ref: this.listRef, className: m("k-group k-menu-group k-reset", (e = {}, e["k-menu-group-".concat(O.sizeMap[this.props.size] || this.props.size)] = this.props.size, e)) }, this.renderChildItems())
      );
    }, s.prototype.renderChildItems = function() {
      var n = this, e = this.props, t = e.item, o = e.itemRender, p = e.textField;
      return this.buttonsData.length > 0 ? this.buttonsData.map(function(l, c) {
        return d.createElement(w, { className: "k-menu-item", dataItem: l, textField: p, focused: n.state.focusedIndex === c, onClick: n.onItemClick, onDown: n.onItemDown, render: o, item: t, index: c, key: c, id: "".concat(n.guid, "-").concat(c) });
      }) : null;
    }, s.prototype.isItemDisabled = function(n) {
      return this.buttonsData[n] ? this.buttonsData[n].disabled : this.props.disabled;
    }, s.prototype.isRtl = function() {
      return this.props.dir !== void 0 ? this.props.dir === "rtl" : !!this.wrapper && getComputedStyle(this.wrapper).direction === "rtl";
    }, s.propTypes = {
      accessKey: i.string,
      ariaLabel: i.string,
      title: i.string,
      onFocus: i.func,
      onBlur: i.func,
      onItemClick: i.func,
      onOpen: i.func,
      onClose: i.func,
      items: i.arrayOf(i.any),
      textField: i.string,
      tabIndex: i.number,
      disabled: i.bool,
      icon: i.string,
      svgIcon: P,
      iconClass: i.string,
      imageUrl: i.string,
      popupSettings: i.object,
      itemRender: i.func,
      item: i.func,
      className: i.string,
      buttonClass: i.string,
      dir: i.string
    }, s.defaultProps = {
      size: "medium",
      rounded: "medium",
      fillMode: "solid",
      themeColor: "base"
    }, s;
  }(d.Component)
);
export {
  R as D
};
